import { z } from 'zod';
import {requiredText} from "~/common/utils/schemaUtil.ts";

export const createInventorySchema = z.object({
  name: requiredText(40),
  action: z.enum(["salesorderset", "empty"])
});